import { render, staticRenderFns } from "./VueRecaptcha.vue?vue&type=template&id=57523adc&scoped=true&"
import script from "./VueRecaptcha.vue?vue&type=script&lang=js&"
export * from "./VueRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57523adc",
  null
  
)

export default component.exports